<template>
  <div class="form-group">
    <div class="form">
      <label class="custom-label">{{$t('ct-counter-init')}}
        <input type="number" class="custom-input form-control " :min="min" :max="max" v-model="valueInit"
               @change="changeValue"
               @keyup="changeValue">
      </label>
    </div>
    <div class="form">
      <label class="custom-label">{{$t('ct-counter-finish')}}
        <input type="number" class="custom-input form-control " :min="min" :max="max" v-model="valueFinish"
               @change="changeValue"
               @keyup="changeValue">
      </label>
    </div>
    <div class="form">
      <label class="custom-label">{{$t('ct-counter-timer')}}
        <input type="number" class="custom-input form-control " :min="min" :max="max" v-model="valueTimer"
               @change="changeValue"
               @keyup="changeValue">
      </label>
    </div>
  </div>
</template>

<script>

	export default {
		name: 'TextCounterComponent',
		data() {
			return {
				element: null,
				valueInit: 0,
				valueFinish: 1000,
				valueTimer: 2,
				min: 0,
				max: 100,
				labelDesc: 'opa',
				callback:
					null,
				defaultValue:
					''
			}
		},
		methods: {
			changeValue() {

				if (this.valueInit < this.min) {
					this.valueInit = this.min;
				}
				if (this.valueFinish < this.min) {
					this.valueFinish = this.min;
				}
				if (this.valueTimer < this.min) {
					this.valueTimer = this.min;
				}

				if (this.valueInit > this.max) {
					this.valueInit = this.max;
				}
				if (this.valueFinish > this.max) {
					this.valueFinish = this.max;
				}
				if (this.valueTimer > this.max) {
					this.valueTimer = this.max;
				}

				this.callback();
			},
			setValues(obj) {

				this.valueInit = obj.init;
				this.valueFinish = obj.finish;
				this.valueTimer = obj.timer;

				this.min = obj.min;
				this.max = obj.max;

				this.element = obj.element;

				this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
				this.callback = obj.callback;
			}
		},
	}

</script>

<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/TextCounter.vue